import { classNames } from '@modules/classname-helpers';
import { Box, Text } from '@ui-lib';
import type { FC, ReactNode } from 'react';

import * as styles from './ExplanationPill.css';

interface ExplanationPillProps {
  children: ReactNode;
}

export const ExplanationPill: FC<ExplanationPillProps> = ({ children }) => {
  return (
    <Box className={classNames(styles.Pill)}>
      <Text className={classNames(styles.PillText)} size="small">
        {children}
      </Text>
    </Box>
  );
};
